// src/theme.ts
import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import { deepmerge } from "@mui/utils";
import { theme } from "./cuttlecore";
import { overrideOptions } from "./override-styles";

declare module "@mui/material/styles" {
  interface BreakpointOverrides {
    xs: false; // removes the `xs` breakpoint
    xl: false;
  }
}

declare module "@mui/material/Button" {
  interface ButtonPropsVariantOverrides {
    nav: true;
  }
}

const mergeThemes = createTheme({
  ...deepmerge(theme, overrideOptions),

  breakpoints: {
    values: {
      sm: 0,
      md: 800,
      lg: 1280,
    },
  },
});

// https://mui.com/material-ui/customization/theming/#responsivefontsizes-theme-options-theme
export const merged = responsiveFontSizes(mergeThemes, {
  factor: 2,
  breakpoints: ["sm", "md", "lg"],
});
